// extracted by mini-css-extract-plugin
export default {"event-share":"EventShare_event-share__QiXYi","event-share__title":"EventShare_event-share__title__Ncm9m"};